import { Pipe, PipeTransform } from '@angular/core';
import { InputRow } from '../base-table.interface';

export type RowSorter<T> = (rowA: T, rowB: T) => number;

@Pipe({ name: 'tableSort' })
export class TableSortPipe<T, G, E> implements PipeTransform {
    public transform(
        values: InputRow<T, G, E>[] | null | undefined,
        sorter: RowSorter<InputRow<T, G, E>>
    ): unknown {
        if (!values || !sorter) {
            return values;
        }

        return [...values].sort(sorter);
    }
}
